import { Role } from 'domain/rbac/RbacDomains';
import moment from 'moment';

export const initialRole = (): Role => {
  return {
    name: '',
    enabled: true,
    menu: [
      {
        baseMenu: 'Dashboard',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Cases',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Entity',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Graph',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'CaseConfiguration',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Watchlist',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'WatchlistAlert',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'CustomList',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Transaction',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'List',
        permission: 'No Permission',
        subMenu: [
          {
            baseMenu: 'TableList',
            permission: 'No Permission',
            subMenu: [],
          },
          {
            baseMenu: 'QueryList',
            permission: 'No Permission',
            subMenu: [],
          },
        ],
      },
      {
        baseMenu: 'Stream',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Enrichment',
        permission: 'No Permission',
        subMenu: [
          {
            baseMenu: 'EnrichmentVelocity',
            permission: 'No Permission',
            subMenu: [],
          },
          {
            baseMenu: 'EnrichmentList',
            permission: 'No Permission',
            subMenu: [],
          },
          {
            baseMenu: 'EnrichmentApi',
            permission: 'No Permission',
            subMenu: [],
          },
          {
            baseMenu: 'EnrichmentQuery',
            permission: 'No Permission',
            subMenu: [],
          },
          {
            baseMenu: 'EnrichmentBasic',
            permission: 'No Permission',
            subMenu: [],
          },
        ],
      },
      {
        baseMenu: 'Rule',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Connection',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Struct',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Ai-Model',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Tracker',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'ACH',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Action',
        permission: 'No Permission',
        subMenu: [],
      },
      {
        baseMenu: 'Sandbox',
        permission: 'No Permission',
        subMenu: [
          {
            baseMenu: 'SandboxSimulator',
            permission: 'No Permission',
            subMenu: [],
          },
          {
            baseMenu: 'SandboxCsv',
            permission: 'No Permission',
            subMenu: [],
          },
          {
            baseMenu: 'SandboxJson',
            permission: 'No Permission',
            subMenu: [],
          },
        ],
      },
    ],
    createdDate: moment().valueOf(),
    lastUpdated: moment().valueOf(),
  };
};
